import axios from 'axios';

export default {
  getSidebar: () => axios.get('menu'),
};
